import React from 'react';
import { Col, FormGroup, Label, Input, Row, Badge } from 'reactstrap';
import { H5, Image } from 'AbstractElements';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PostCommon from 'Component/Common/Form/Post';
import DropzoneCommon from 'Component/Common/Upload/Dropzone';
import { submitProduct } from 'Services/Features/Product/Utils/productUtils';
import { setFormData, resetFormData } from 'Services/Features/Product/productSlice';
import CustomLoader from 'Component/Common/CustomLoader';
import MultipleInput from 'Component/DashboardQeza/Treatment/Form/MultipleInput';
import SelectCategoryProduct from './SelectCategoryProduct';
import { formatPrice } from 'Component/DashboardQeza/Common/PriceUtils';
import { toast } from 'react-toastify';

const ProductForm = ({ label, setRefetch }) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const data = useSelector(state => state.product.currentProduct)
    const startUpload = useSelector(state => state.product.loading);

    const handleSuccess = () => {
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/products`);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (data.tiktok_url || data.shopee_url || data.tokopedia_url) {
            const urlPattern = /^(https?:\/\/)?([\w\d-]+\.)+\w{2,}(\/.*)?$/;
            if ((data.tiktok_url && !urlPattern.test(data.tiktok_url)) || (data.shopee_url && !urlPattern.test(data.shopee_url)) || (data.tokopedia_url && !urlPattern.test(data.tokopedia_url))) {
                toast.warn("Masukkan URL yang valid!");
                return;
            }
        }
        dispatch(submitProduct({ ...data, successCallback: handleSuccess }))
    };

    const handleDiscard = (e) => {
        e.preventDefault();
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/products`);
    };

    const handlePriceChange = (e) => {
        const rawValue = e.target.value.replace(/\./g, ""); // Hilangkan titik untuk dapatkan angka asli
        const { name } = e.target;
        if (!isNaN(rawValue)) {
            handleChanges({ target: { name: name, value: rawValue } });
        }
    };

    const handleChanges = (e) => {
        const { name, value } = e.target;
        dispatch(setFormData({ [name]: value }));
    }

    const handleChangePhotos = ({ meta, file }, status) => {
        if (status === 'done') {
            dispatch(setFormData({ 'photo': file }));
        } else if (status === 'removed') {
            dispatch(setFormData({ 'photo': null }));
        }
    };


    return (
        <PostCommon title={label} handleSubmit={handleSubmit} handleDiscard={handleDiscard} >
            {startUpload && (
                <CustomLoader />
            )}
            <div>
                <Row className="mb-3">
                    <Col sm={6}>
                        <FormGroup className='mb-3'>
                            <Label for="validationName" style={{ fontWeight: 'bold' }}>Nama :</Label>
                            <Input
                                className="form-control"
                                id="validationName"
                                type="text"
                                name="name"
                                placeholder="Masukkan nama produk..."
                                required=""
                                value={data.name}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={6}>
                        <FormGroup className='mb-3'>
                            <Label for="validationCategoyId" style={{ fontWeight: 'bold' }}>Kategori :</Label>
                            <SelectCategoryProduct />
                        </FormGroup>
                    </Col>
                    <Col sm={6}>
                        <FormGroup className='mb-3'>
                            <Label for="validationPrice" style={{ fontWeight: 'bold' }}>Harga :</Label>
                            <Input className="form-control" id="validationPrice" type="text" onWheel={(e) => e.target.blur()} name="price" placeholder="Masukkan harga produk..." required=""
                                onKeyDown={(e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                        e.preventDefault();
                                    }
                                }}
                                value={formatPrice(data.price)}
                                onChange={handlePriceChange} />
                        </FormGroup>
                    </Col>
                    <Col sm={6}>
                        <FormGroup className='mb-3'>
                            <Label for="validationGimmicPrice" style={{ fontWeight: 'bold' }}>Harga Coret :</Label>
                            <Input className="form-control" id="validationGimmicPrice" type="text" onWheel={(e) => e.target.blur()} name="gimmick_price" placeholder="Masukkan harga coret produk..." required=""
                                onKeyDown={(e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                        e.preventDefault();
                                    }
                                }}
                                value={formatPrice(data.gimmick_price)}
                                onChange={handlePriceChange} />
                        </FormGroup>
                    </Col>
                    <Col sm={12}>
                        <FormGroup className='mb-3'>
                            <Label for="validationTiktokUrl" style={{ fontWeight: 'bold' }}>Link <Badge color="dark" className="badge" style={{ fontSize: '12px'}}>Tiktok</Badge> Produk :</Label>
                            <Input className="form-control" id="validationTiktokUrl" type="text" onWheel={(e) => e.target.blur()} name="tiktok_url" placeholder="Masukkan URL (contoh: https://www.tiktok.com/@qeza.officialstore/video/7463759635695062288 atau www.tiktok.com/@qeza.officialstore/video/7463759635695062288)"
                                value={data.tiktok_url}
                                onChange={handleChanges} />
                        </FormGroup>
                    </Col>
                    <Col sm={12}>
                        <FormGroup className='mb-3'>
                            <Label for="validationShopeeUrl" style={{ fontWeight: 'bold' }}>Link <Badge color="primary" className="badge" style={{ fontSize: '12px'}}>Shopee</Badge> Produk :</Label>
                            <Input className="form-control" id="validationShopeeUrl" type="text" onWheel={(e) => e.target.blur()} name="shopee_url" placeholder="Masukkan URL (contoh: https://shopee.co.id/qezastore/28920991160 atau www.shopee.co.id/qezastore/28920991160)"
                                value={data.shopee_url}
                                onChange={handleChanges} />
                        </FormGroup>
                    </Col>
                    <Col sm={12}>
                        <FormGroup className='mb-3'>
                            <Label for="validationTokopediaUrl" style={{ fontWeight: 'bold' }}>Link <Badge color="success" className="badge" style={{ fontSize: '12px'}}>Tokopedia</Badge> Produk :</Label>
                            <Input className="form-control" id="validationTokopediaUrl" type="text" onWheel={(e) => e.target.blur()} name="tokopedia_url" placeholder="Masukkan URL (contoh: https://tokopedia.link/j1GyVTuclSb atau www.tokopedia.link/j1GyVTuclSb)"
                                value={data.tokopedia_url}
                                onChange={handleChanges} />
                        </FormGroup>
                    </Col>
                    <Col sm={12}>
                        <FormGroup className='mb-3'>
                            <Label for="validationBenefits" style={{ fontWeight: 'bold', display: 'block' }}>
                                Cara Penggunaan :
                                <span style={{ fontSize: '12px', fontStyle: 'italic', fontWeight: 'normal', color: '#6c757d', display: 'block' }}>
                                    Tata cara penggunaan produk, misal: Bersihkan wajah dengan sabun pembersih wajah, Oleskan serum ke wajah secara merata, dll.
                                </span>
                            </Label>
                            <MultipleInput 
                                name="how_to_use"
                                initialData={data.how_to_use}
                                placeholder="Cara penggunaan produk"
                                onChange={(name, value) => dispatch(setFormData({ [name]: value }))} 
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={data.photoLink ? 12 : 6}>
                        <FormGroup className='mb-3'>
                            <Label for="validationDescription" style={{ fontWeight: 'bold' }}>Deskripsi Produk :</Label>
                            <Input className="form-control" id="validationDescription" type="textarea" name="description" placeholder="Masukkan deskripsi produk..." required=""
                                value={data.description}
                                onChange={handleChanges} 
                                style={{ height: data.id ? '200px' : '120px', overflow: 'scroll' }}
                                onInput={(e) => {
                                    e.target.style.height = "auto";
                                    e.target.style.height = `${e.target.scrollHeight}px`;
                                }}/>
                        </FormGroup>
                    </Col>
                    {data.photoLink && (
                        <Col sm="4" className="mb-3">
                            <H5>Preview</H5>
                            <Image attrImage={{ className: 'img-fluid', src: data.photoLink, alt: `${data.name}`, style: { height: '100%', objectFit: 'contain', borderRadius: '18px' } }} />
                        </Col>
                    )}
                    <Col sm={data.photoLink ? 8 : 6}>
                        <DropzoneCommon
                            label={'Foto produk'}
                            inputContent={'Update foto produk'}
                            handleChangeStatus={handleChangePhotos}
                            accept="image/*"
                            multiple={false}
                        />
                    </Col>
                </Row>
            </div>
        </PostCommon>
    );
};

export default ProductForm;